import 'webp-in-css/polyfill';
import 'bootstrap/js/dist/popover';

import '@front/lib/icons';
import '@front/lib/lazyload';

import backTop from '@front/components/backTop';
import categorySearch from '@front/components/categorySearch';
import ekomi from '@front/components/ekomi';
import modals from '@front/components/modals';
import passwordStrength from '@front/components/passwordStrength';
import productSelector from '@front/components/productSelector';
import productQuestion from '@front/components/productQuestion';
import selector from '@front/components/selector';
import upload from '@front/components/upload';

import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse';

import datalayer from '@front/plugins/datalayer';
import obfuscatedLink from '@front/plugins/obfuscated-link';

import './pages/customer';
import product from './pages/product';
import './pages/payment';
import './cart';

import fractomenu from './modules/fractomenu';

import { createApp } from '@front/utils/alpine';

const modules = {
    fractomenu,
};

const components = {
    backTop,
    categorySearch,
    ekomi,
    modals,
    product,
    passwordStrength,
    productSelector,
    productQuestion,
    selector,
    upload,
};

const plugins = [intersect, persist, collapse, datalayer, obfuscatedLink];

createApp(
    {
        modules,
        components,
    },
    plugins,
    {}
);
